const list = {
    buttonList: [
        {
            jurName: "新增",
            actionType: 0,
        },
        {
            jurName: "修改",
            actionType: 1,
        },
        {
            jurName: "删除",
            actionType: 2,
        },
    ],
    searchList: [
        {
            showField: "类型名称",
            entityField: "surgeryName",
            isShow: 1,
            fieldType: "string",
            searchId: null,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        }
    ],
    dataList: [
        {
            showField: "类型名称",
            entityField: "surgeryName",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            fieldWeight: 120,
        },
        {
            showField: "助记码",
            entityField: "surgeryCode",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            fieldWeight: 120,
        },
        {
            showField: "手术类型",
            entityField: "surgeryType",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            fieldWeight: 120,
        },
        {
            showField: "排序",
            entityField: "sort",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            fieldWeight: 120,
        }
    ]
}
export default list
